import { ChangeDetectorRef, Component, input, Input, OnInit, output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurveyJsComponent } from './survey-js/survey-js.component';
import { SurveyBuilderComponent } from './survey-builder/survey-builder.component';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { loadStripe } from '@stripe/stripe-js';  // Stripe.js
import { environment as env } from '@env/environment';
import { concatCommunityAddress, IFileModel, CampaignTypeEnum, ITEM_TYPE_ENUM, ViewParticipateService, IPaymentIntentRequest, IPaymentIntentResponse, ICommunity, DateLevelEnum, AuthStateService, PlatformService, NavigationService, TooltipDirective, CampaignTypeEnumm } from '@sml/utility';
import { ItemListingTypeEnum } from '@sml/utility';
import { DialogComponent } from '@sml/dialog';
import { ButtonsModule } from '@sml/buttons';
import { Router } from '@angular/router';
import { AppFormService, FormSubmitDto } from '@sml/utility';
import { SpinnerService } from '@sml/spinner';
import { ToastrService } from '@sml/toastr';
import { SafeUrl } from '@angular/platform-browser';
import { IconsComponent } from '@sml/icons';
import { FormSpinnerService } from '@sml/form-spinner';

@Component({
  selector: 'lib-survey',
  imports: [CommonModule, SurveyJsComponent, CommonModule, FormsModule, SurveyBuilderComponent, DialogComponent, ButtonsModule, IconsComponent,TooltipDirective],
  templateUrl: './survey.component.html',
  styleUrl: './survey.component.scss',
  standalone: true,
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SurveyComponent implements OnInit {
  @Input() isProposeForm = false;  // Flag to determine if the component is used for Propose form
  @Input() formTitle = '';  // Title for the form
  @Input() formDescription = '';  // Description for the form 
  @Input() isVolunteer = false;  // Description for the form 
  @Input() timeZoneData: any;  // Timezone data for the form
  @Input() isCalledFromItemDrawer=false
  profileImage!: IFileModel;
  profileUrl!: SafeUrl;
  profilePicture = false;
  campaignTypeEnums=CampaignTypeEnum

  public communityAddress = '';
  private _communityData: ICommunity | undefined;
  isShowPaymentLoader = false;

  @Input()
  set communityData(value: any) {
    this._communityData = value;
    this.communityAddress = concatCommunityAddress(this.communityData);
    this.proposeFormId = this.communityData?.formMasterId || null;
    this.communityId = this.communityData?.id || null;
    if (this.communityData?.profileImageBlob) {
      this.profileImage = JSON.parse(this.communityData.profileImageBlob)[0];
      this.profileUrl = this.profileImage.BlobUrl;
      this.profilePicture = true;
    }
    console.log('communityData set:', value);
  }

  get communityData(): any {
    return this._communityData;
  }

  @Input() isFromParticipateNow = false;  // Flag to determine if the component is used in Participate Now flow
  @Input() previewFormData: any = {};
  stripe: any;
  elements: any;
  card: any;
  bankAccount: any;
  fullName = '';
  email = '';
  phone = '';
  address = '';
  address2 = '';
  city = '';
  postalCode = '';
  country = '';
  cardNumber = '';
  expMonth!: number;
  expYear!: number;
  cvc!: string;
  amount!: number;  // Example amount
  selectedPaymentMethod: string | null = null;  // Default to bank transfer
  @ViewChild(SurveyJsComponent) surveyComponent!: SurveyJsComponent;
  closeParticipateModal = output();
  itemData = input<any | null>(null);
  selectedShift = input<any | null>(null);
  customItemPrice = input<number | null>(null);
  proposeFormId: number | null = null;
  communityId: number | null = null;
  itemTypeEnum = ITEM_TYPE_ENUM;
  formDetailStrings = FORM_DETAIL_STRINGS;
  @ViewChild('smlCancelSurveyModal') smlCancelSurveyModal!: DialogComponent;
  cardOptions = {
    hidePostalCode: true, // Disable postal code field in Stripe Elements
    style: {
      base: {
        color: '#32325d',
        fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
        fontSmoothing: 'antialiased',
        fontSize: '16px',
        '::placeholder': {
          color: '#aab7c4'
        }
      },
      invalid: {
        color: '#fa755a',
        iconColor: '#fa755a'
      }
    }
  };
  showCancelSurveyDialog: boolean = false;
  showContributionModal: boolean = false;
  countryList = [
    { code: "US", name: "United States" },
    { code: "IN", name: "India" },
    { code: "CA", name: "Canada" },
    { code: "GB", name: "United Kingdom" },
    { code: "AU", name: "Australia" },
    { code: "DE", name: "Germany" },
    { code: "FR", name: "France" },
    { code: "IT", name: "Italy" },
    { code: "ES", name: "Spain" },
    { code: "BR", name: "Brazil" },
    { code: "JP", name: "Japan" },
    { code: "CN", name: "China" },
    { code: "MX", name: "Mexico" },
    { code: "NL", name: "Netherlands" },
    { code: "SE", name: "Sweden" },
    { code: "PL", name: "Poland" },
    { code: "SG", name: "Singapore" },
    { code: "HK", name: "Hong Kong" },
    { code: "KW", name: "Kuwait" },
    { code: "SA", name: "Saudi Arabia" }
  ];
  proposeFormDescription: string = 'Please fill out the form below if you’d like to donate, volunteer, or give back in a new way.';
  isGooglePayAvailable = false;
  paymentIntentResponse!: IPaymentIntentResponse;
  paymentRequest: any;
  googlePayButton: any;
  campaignTypeEnum = CampaignTypeEnum;
  apiBaseUrl = 'https://sml-api-dev-dsddhdducjfnbscv.eastus-01.azurewebsites.net/';
  //apiBaseUrl = 'https://localhost:7106/';
  isOverView = false;
  isParticipateForm: boolean = false;
  isMobileView = false;
  dateEnum = DateLevelEnum;
  achElement: any;
  public isLoggedIn = false;

  constructor(private readonly toaster: ToastrService, private readonly cdr: ChangeDetectorRef, private readonly platformService: PlatformService,
    private readonly authState: AuthStateService, private http: HttpClient, private router: Router, private participateService: ViewParticipateService,
    private appFormService: AppFormService, private readonly spinnerService: SpinnerService, private formSpinnerService: FormSpinnerService,
    private readonly navagationService: NavigationService
  ) {
    if (this.platformService.browser()) {
      this.authState.auth.isAuthenticated$.subscribe(isAuthenticated => {
        this.isLoggedIn = isAuthenticated;
      })
    };
  }

  async ngOnInit() {
    this.setIsOverView();
    this.isParticipateForm = this.router.url.includes('/overview') || this.router.url.includes('/gallery') || this.router.url.includes('/map') || this.router.url.includes('/preview');
    this.isMobileView = window.innerWidth < 768;
    // Load Stripe.js with your publishable key
    console.log(this.itemData());
    if (this.itemData().isAcceptPaymentOnline) {
      this.stripe = await loadStripe(env.stripePublishableKey);  // Replace with your actual Stripe publishable key
      this.paymentRequest = this.stripe.paymentRequest({
        country: 'US',
        currency: 'usd',
        total: {
          label: 'Total',
          // amount: this.itemData().price * 100,
          amount: (this.itemData().itemListingType === ItemListingTypeEnum.Custom ? this.customItemPrice() : this.itemData().price) * 100, // Convert to cents
        },
        //requestPayerEmail: true,  // Optionally request email
      });
      const result = await this.paymentRequest.canMakePayment();
      this.isGooglePayAvailable = !!result?.googlePay;
      //this.formSpinnerService.hideFormSpinner();
      this.spinnerService.hideSpinner();

      // return !!(result && result.googlePay);
    }


    //  this.paymentRequest = this.stripe.paymentRequest({
    //       country: 'US',
    //       currency: 'usd',
    //       total: {
    //         label: 'Demo Total',
    //         amount: 100,
    //       },
    //       requestPayerName: true,
    //       requestPayerEmail: true,
    //     });

    //     const elements = this.stripe.elements();
    //     const prButton = elements.create('paymentRequestButton', {
    //       paymentRequest: this.paymentRequest,
    //       // style: {
    //       //   paymentRequestButton: {
    //       //     type: 'googlePay',
    //       //     theme: 'light',
    //       //     height: '40px',
    //       //   },
    //       // },
    //     });

    // this.paymentRequest.canMakePayment().then((result: any) => {
    //   if (result) {
    //     alert(`Google Pay is available: ${JSON.stringify(result)}`);
    //     prButton.mount('#payment-request-button');
    //   } else {
    //     alert(`Google Pay is not available: ${JSON.stringify(result)}`);
    //     console.log('Google Pay is not available');
    //   }
    // });

    // Create Stripe Elements instance
    //this.elements = this.stripe.elements();
    // this.achElement = this.elements.create('usBankAccount', {
    //       supportedCountries: ['US'],
    //     });
    // this.achElement = this.elements.create('usBankAccount');
    //     this.achElement.mount('#iban-element');
    // Prepare PaymentRequest for Google Pay
    // this.paymentRequest = this.stripe.paymentRequest({
    //   country: 'US',
    //   currency: 'usd',
    //   total: {
    //     label: 'Total',
    //     amount: this.amount,
    //   },
    //   requestPayerName: true,
    //   requestPayerEmail: true,
    // });

    //   this.paymentRequest = this.stripe.paymentRequest({
    //   country: 'US',
    //   currency: 'usd',
    //   // country: 'IN', // Set to 'IN' for India
    //   // currency: 'inr',
    //   total: {
    //     label: 'Total',
    //     amount: this.amount, // in cents
    //   },
    //   requestPayerName: true,
    //   requestPayerEmail: true,
    //   supportedPaymentMethods: [
    //     {
    //       supportedMethods: 'google_pay',
    //       data: {
    //         environment: 'TEST', // change to 'PRODUCTION' in live
    //         apiVersion: 2,
    //         // apiVersionMinor: 0,
    //         allowedPaymentMethods: ['CARD', 'TOKENIZED_CARD'],
    //         paymentMethodTokenizationParameters: {
    //           tokenizationType: 'PAYMENT_GATEWAY',
    //           parameters: {
    //             gateway: 'stripe',
    //             // 'stripe:version': '2020-08-27',
    //             'stripe:version': '2024-04-10',
    //             'stripe:publishableKey': env.stripePublishableKey,
    //           },
    //         },
    //         allowedCardNetworks: ['VISA', 'MASTERCARD'],
    //         allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
    //       },
    //     },
    //   ],
    // });


    // Check if Google Pay is available
    //   try {
    //   const result = await this.paymentRequest.canMakePayment();
    //   //alert('Google Pay availability: ' + JSON.stringify(result));
    //   console.log('Google Pay availability:', result);
    //   // const result = await this.paymentRequest.canMakePayment();
    //   // console.log('Google Pay availability:', result);

    //   //if (result && result.googlePay) {
    //   if (result) {
    //     // Create and mount the Google Pay button
    //     // this.googlePayButton = this.elements.create('paymentRequestButton', {
    //     //   paymentRequest: this.paymentRequest,
    //     //   style: {
    //     //     paymentRequestButton: {
    //     //       type: 'googlePay',
    //     //       theme: 'light',
    //     //       height: '40px',
    //     //     },
    //     //   },
    //     // });
    //     // this.googlePayButton.mount('#google-pay-button');
    //     // setTimeout(() => {
    //       // this.googlePayButton = this.elements.create('paymentRequestButton', {
    //       //   paymentRequest: this.paymentRequest,
    //         // style: {
    //         //   paymentRequestButton: {
    //         //     type: 'googlePay',
    //         //     theme: 'light',
    //         //     height: '40px',
    //         //   },
    //         // },
    //       // });
    //       // this.googlePayButton.mount('#google-pay-button');
    //     // });
    //   }
    // } catch (error) {
    //   alert('Error checking Google Pay availability: ' + error);
    //   console.error('Error checking Google Pay availability:', error);
    // }

    // Handle payment method events
    // this.paymentRequest.on('paymentmethod', async (ev: any) => {
    //   // Confirm the PaymentIntent on the server
    //   const response = await this.http.post<any>(
    //     `${env.apiUrl}StripePayment/api/payment/create-payment-intent`,
    //     {
    //       amount: this.amount,
    //       currency: 'usd',
    //       email: this.email,
    //       name: 'Customer Name',
    //       phone: this.phone,
    //       addressLine1: this.address,
    //       addressLine2: this.address2,
    //       city: this.city,
    //       postalCode: this.postalCode,
    //       country: this.country,
    //       // paymentMethod: 'gpay',
    //       paymentMethod: 'card',
    //     }
    //   ).toPromise();

    //   alert('Response from backend: ' + JSON.stringify(response));

    //   const clientSecret = response?.clientSecret || response?.data?.clientSecret;
    //   const { error } = await this.stripe.confirmCardPayment(
    //     clientSecret,
    //     { payment_method: ev.paymentMethod.id },
    //     { handleActions: false }
    //   );

    //   if (error) {
    //     ev.complete('fail');
    //     alert(error.message);
    //   } else {
    //     ev.complete('success');
    //     // Optionally, handle post-payment actions here
    //     alert('Google Pay payment successful!');
    //   }
    // });
  }

  private setIsOverView() {
    this.isOverView = this.router.url.includes('/overview') || this.router.url.includes('/gallery') || this.router.url.includes('/map')
      || this.router.url.includes('/custom-grid') || this.router.url.includes('/custom-form-builder')
      || this.router.url.includes('/custom-template-form-builder') || this.router.url.includes('/custom-template-grid')
      || this.router.url.includes('/item/add') || this.router.url.includes('/item/update')
      || this.router.url.includes('/create') || this.router.url.includes('/map') || this.router.url.includes('/preview');
  }

  // async createPaymentIntent(amount: number) {
  //   const stripe = await this.stripe;
  //   const response = await fetch('YOUR_BACKEND_URL/payment_intent', {
  //     method: 'POST',
  //     headers: { 'Content-Type': 'application/json' },
  //     body: JSON.stringify({ amount }),
  //   });
  //   const { clientSecret } = await response.json();
  //   return clientSecret;
  // }

  onClose() {
    this.closeParticipateModal.emit();
  }
  isEmpty(obj: any): boolean {
    return !obj || Object.keys(obj).length === 0;
  }

  onCloseForm() {
    // const isMobileView = window.innerWidth < 768;
    // if (isMobileView) {
    //   setTimeout(() => {
    //     window.scrollTo({
    //       top: document.body.scrollHeight,
    //       behavior: 'smooth'
    //     });
    //   }, 100);
    // }
    const isNonLoggedInParticipate = this.router.url.includes('/preview');
    if ((this.isParticipateForm || this.isProposeForm || (!this.isLoggedIn && isNonLoggedInParticipate)) && !this.isCalledFromItemDrawer) {
      this.participateService.showParticipateConfPopup(true);
      // this.showCancelSurveyDialog = true;
      // setTimeout(() => {
      //   this.smlCancelSurveyModal.openModal();
      // }, 100);
      return;
    }
    this.closeParticipateModal.emit();
  }


  paymentMethodHandler: any;

  resetPaymentMethod() {
    this.selectedPaymentMethod = null; // Reset the selected payment method
    this.cdr.detectChanges(); // Trigger change detection to update the view
  }

  isPaymentIntentLoaded = false
  onPaymentMethodChange(method: string) {
    this.isPaymentIntentLoaded = false;
    console.log('Payment method changed:', method);
    // Add any logic you want to run when the payment method changes
    // For example, reset fields, trigger API calls, etc.
    // Create the Payment Request for ACH and other methods

    const isError = this.surveyComponent.isFormInvalid(); // Validate the form before submission

    if (isError) {
      this.showFormError();    // this.cdr.detectChanges();
      //this.selectedPaymentMethod = ''; // Reset the model value
      setTimeout(() => {
        this.selectedPaymentMethod = ''; // Reset the model value
        // this.cdr.detectChanges();  // Force a second detection
      }, 0);

      return;
    }

    const firstName = this.surveyComponent.getFormValue('FirstName') || '';
    const lastName = this.surveyComponent.getFormValue('LastName') || '';
    this.fullName = `${firstName} ${lastName}`;
    this.email = this.surveyComponent.getFormValue('Email') || '';
    this.phone = this.surveyComponent.getFormValue('Phone') || '';
    this.postalCode = this.surveyComponent.getFormValue('ZipCode') || '';

    try {
      const paymentIntentRequest: IPaymentIntentRequest = {
        // amount: this.itemData().price * 100, // Convert to cents
        amount: (this.itemData().itemListingType === ItemListingTypeEnum.Custom ? this.customItemPrice() : this.itemData().price) * 100, // Convert to cents
        // currency: 'usd',
        email: this.email,
        name: this.fullName, // You can fetch this dynamically from your form
        phone: this.phone,
        // addressLine1: this.address,
        // addressLine2: this.address2,
        // city: this.city,
        postalCode: this.postalCode,
        // country: this.country,
        paymentMethod: this.selectedPaymentMethod === 'gpay' ? 'card' : this.selectedPaymentMethod, // Use 'card' for Google Pay
        metaData: {
          "ItemId": this.itemData().itemId ?? '',
          "Quantity": this.itemData().quantity ? String(this.itemData().quantity) : '',
          "RemainingQuantity": this.itemData().remainingQuantity ? String(this.itemData().remainingQuantity) : '',
          "PaymentMethod": this.selectedPaymentMethod ?? '',
          "IPAddress": this.navagationService.ipAddress || '',
        }
      }

      if (this.itemData()?.isAcceptPaymentOnline) {
        // Include current form values in the create-payment-intent call so backend can persist them
        const currentFormValues = this.surveyComponent?.getSurveyDataSnapshot?.() ?? {};
        const formSubmitDtoPayload = {
          itemId: this.itemData()?.id,
          communityId: this.itemData()?.communityId ?? this.communityId,
          isOnlinePayment: !!this.itemData()?.isAcceptPaymentOnline,
          formValues: currentFormValues,
          formId: this.itemData().formMasterId ?? this.proposeFormId,
          isVolunteer:
            this.itemData()?.campaignTypeId ===
            CampaignTypeEnum['Volunteer Activity'],
          volunteerShiftId: this.selectedShift()?.id,
          paymentMethod:
            this.itemData()?.isAcceptPaymentOnline && this.selectedPaymentMethod
              ? this.selectedPaymentMethod === 'bank'
                ? 54
                : 53
              : undefined,
          price: this.itemData()?.isAcceptPaymentOnline
            ? this.itemData().itemListingType === ItemListingTypeEnum.Custom
              ? this.customItemPrice()
              : this.itemData().price
            : undefined,
        };
        paymentIntentRequest.formSubmitDtoJson = JSON.stringify(formSubmitDtoPayload);
      }
      
      //this.http.post<any>(`${this.apiBaseUrl}StripePayment/api/payment/create-payment-intent`, {
      this.appFormService.getPaymentIntent(paymentIntentRequest).subscribe({
        next: response => {
          console.log('Response from backend:', response);
          if (response) {
            this.paymentIntentResponse = response;
          } else {
            console.error('Failed to receive clientSecret from the backend.');
            return;
          }

          this.elements = this.stripe.elements({ clientSecret: this.paymentIntentResponse.clientSecret });

          // // Create the Payment Request for ACH and other methods
          // this.paymentRequest = this.stripe.paymentRequest({
          //   country: 'US',
          //   currency: 'usd',
          //   total: {
          //     label: 'Total',
          //     amount: this.itemData().price * 100,
          //   },
          //   //requestPayerEmail: true,  // Optionally request email
          // });

          if (this.selectedPaymentMethod === 'gpay') {
            // this.paymentRequest.on('paymentmethod', async (ev: any) => {
            //   // Confirm the PaymentIntent on the server
            //   // const response = await this.http.post<any>(
            //   //   `${env.apiUrl}StripePayment/api/payment/create-payment-intent`,
            //   //   {
            //   //     amount: this.amount,
            //   //     currency: 'usd',
            //   //     email: this.email,
            //   //     name: 'Customer Name',
            //   //     phone: this.phone,
            //   //     addressLine1: this.address,
            //   //     addressLine2: this.address2,
            //   //     city: this.city,
            //   //     postalCode: this.postalCode,
            //   //     country: this.country,
            //   //     // paymentMethod: 'gpay',
            //   //     paymentMethod: 'card',
            //   //   }
            //   // ).toPromise();

            //   // alert('Response from backend: ' + JSON.stringify(response));

            //   const clientSecret = response?.clientSecret || response?.data?.clientSecret;
            //   const { error, paymentIntent } = await this.stripe.confirmCardPayment(
            //     clientSecret,
            //     { payment_method: ev.paymentMethod.id },
            //     { handleActions: false }
            //   );

            //   if (error) {
            //     ev.complete('fail');
            //     alert(error.message);
            //   } else {
            //     ev.complete('success');
            //     alert('Google Pay payment successful!');
            //   }
            // });

            //   this.paymentRequest.on('paymentmethod', async (ev: any) => {
            //   const clientSecret = response?.clientSecret || response?.data?.clientSecret;

            //   const { error, paymentIntent } = await this.stripe.confirmCardPayment(
            //     clientSecret,
            //     { payment_method: ev.paymentMethod.id },
            //     { handleActions: false }
            //   );

            //   console.log('Response from confirmCardPayment:', { error, paymentIntent });

            //   if (error) {
            //     ev.complete('fail');
            //     alert(error.message);
            //     return;
            //   }

            //   // Check if additional action is required
            //   if (paymentIntent.status === 'requires_action') {
            //     const { error: confirmError, paymentIntent: finalPaymentIntent } = await this.stripe.confirmCardPayment(clientSecret);

            //     if (confirmError) {
            //       ev.complete('fail');
            //       alert(confirmError.message);
            //       return;
            //     }

            //     if (finalPaymentIntent.status === 'succeeded') {
            //       ev.complete('success');
            //       alert('Google Pay payment successful after retry!');
            //     } else {
            //       ev.complete('fail');
            //       alert('Payment failed.');
            //     }
            //   } else if (paymentIntent.status === 'succeeded') {
            //     ev.complete('success');
            //     alert('Google Pay payment successful!');
            //   } else {
            //     ev.complete('fail');
            //     alert('Unexpected payment status.');
            //   }
            // });

            this.paymentRequest.off('paymentmethod', this.paymentMethodHandler);
            this.paymentMethodHandler = async (ev: any) => {

              //const isError = this.surveyComponent.isFormInvalid(); // Validate the form before submission
              // const isError = true;// Validate the form before submission
              // if(isError){
              //   // this.toaster.error({ message: `Fill mandatory details`, title: "Error saving form " });
              //   ev.complete('fail'); 
              // setTimeout(async () => {
              //       this.selectedPaymentMethod = null;
              //       this.toaster.error({ message: !this.isValidFilesSize ? 'Invalid Attachement Size' : `Invalid Form`, title: "Error in form " });
              //       this.cdr.detectChanges();
              //     }, 0);
              //this.selectedPaymentMethod = ''; // Reset the model value
              //  setTimeout(() => {
              //       this.selectedPaymentMethod = ''; // Reset the model value
              //       this.cdr.detectChanges();  // Force a second detection
              //   }, 0);
              //return;
              // }
              // else{

              const clientSecret = this.paymentIntentResponse.clientSecret;

              try {
                // Step 1: Confirm the payment with Stripe
                const { error, paymentIntent } = await this.stripe.confirmCardPayment(
                  clientSecret,
                  { payment_method: ev.paymentMethod.id },
                  { handleActions: false }
                );

                if (error) {
                  // If there's an error, fail the flow and show message
                  ev.complete('fail');
                  this.toaster.error({ message: error?.message ?? 'Unknown Error', title: "Payment Failed" });
                  console.error(`Error: ${error.message}`);  // Log error instead of alert
                  return;
                }

                // **Immediately complete the Google Pay flow as soon as payment succeeds**
                if (paymentIntent.status === 'succeeded') {
                  ev.complete('success');  // Immediately complete Google Pay UI
                  //console.log('Payment successful!');  // Log success instead of alert
                  setTimeout(async () => {
                    console.log('Payment successful!');  // Log success
                    // Execute your API call or any subsequent logic here
                    //this.formSpinnerService.showFormSpinner();    
                    this.spinnerService.showSpinner();                   // this.toaster.success({ message: `Payment done with ${this.selectedPaymentMethod}`, title: "Success Payment" });                
                    this.participateService.hideParticipate();
                    this.surveyComponent.completeSurvey();

                    // Do any further actions here after API call is completed
                    console.log('API call complete');
                  }, 0);
                } else if (paymentIntent.status === 'requires_action') {
                  // If further action is required, attempt to confirm again
                  const { error: retryError, paymentIntent: finalPaymentIntent } = await this.stripe.confirmCardPayment(clientSecret);

                  if (retryError) {
                    ev.complete('fail');
                    this.toaster.error({ message: retryError?.message ?? 'Unknown Error', title: "Payment Failed" });
                    console.error(`Retry Error: ${retryError.message}`);
                    return;
                  }

                  if (finalPaymentIntent.status === 'succeeded') {
                    ev.complete('success');  // Immediately complete Google Pay UI
                    setTimeout(async () => {
                      console.log('Payment successful after retry!');
                      // Execute your API call or any subsequent logic here
                      //this.formSpinnerService.showFormSpinner();   
                      this.spinnerService.showSpinner();               
                      this.participateService.hideParticipate();
                      this.surveyComponent.completeSurvey();

                      // Do any further actions here after API call is completed
                      console.log('API call complete');
                    }, 0);
                  } else {
                    ev.complete('fail');
                    this.toaster.error({ message: finalPaymentIntent.status ?? 'Unknown Error', title: "Payment Failed" });
                    console.error('Payment failed after retry.');
                  }
                } else {
                  ev.complete('fail');
                  this.toaster.error({ message: paymentIntent.status ?? 'Unknown Error', title: "Payment Failed" });
                  console.error(`Unexpected payment status: ${paymentIntent.status}`);
                }
              } catch (error) {
                ev.complete('fail');
                this.toaster.error({ message: 'Unknown Error', title: "Payment Failed" });
                console.error(`Error during payment flow: ${error}`);
              }
              //}
            }
            this.paymentRequest.on('paymentmethod', this.paymentMethodHandler);


          }
          // Handle payment method events

          // this.paymentRequest = this.stripe.paymentRequest({
          //     country: 'US',
          //     currency: 'usd',
          //     total: {
          //       label: 'Demo Total',
          //       amount: 100,
          //     },
          //     requestPayerName: true,
          //     requestPayerEmail: true,
          //   });

          this.googlePayButton = this.elements.create('paymentRequestButton', {
            paymentRequest: this.paymentRequest,
            // style: {
            //   paymentRequestButton: {
            //     type: 'googlePay',
            //     theme: 'light',
            //     height: '40px',
            //   },
            // },
          });


          // Create individual elements for card number, expiry, and CVC
          //this.card = this.elements.create('card', this.cardOptions);

          this.card = this.elements.create('card');

          this.bankAccount = this.elements.create('payment', {
            // fields: { billingDetails: 'auto' }, // Optional: auto-collect billing details
            fields: {
              billingDetails: {
                name: 'never',
                email: 'never', // This hides the email field
              },
            },
            paymentMethodOrder: ['us_bank_account'],
            //style: this.cardOptions.style
          });

          this.mountElement(this.selectedPaymentMethod || '');
        },
        error: error => {
          console.error('API error:', error);
        }
      });



      // ...rest of your code...
    } catch (error) {
      console.error('API error:', error);
    }
  }

  // Mount the selected Stripe Element based on the selected payment method
  mountElement(paymentMethod: string) {

    // Unmount the previously mounted element
    if (this.card && this.card.isMounted) {
      this.card.unmount();
    }
    if (this.bankAccount && this.bankAccount.isMounted) {
      this.bankAccount.unmount();
    }
    if (this.googlePayButton && this.googlePayButton.isMounted) {
      this.googlePayButton.unmount();
    }

    // Mount the selected element
    if (paymentMethod === 'card') {
      this.card.mount('#card-element');
      this.isPaymentIntentLoaded = true;
    } else if (paymentMethod === 'bank') {
      this.bankAccount.mount('#bank-account-element');
      this.isPaymentIntentLoaded = true;
    } else if (paymentMethod === 'gpay') {
      this.paymentRequest.canMakePayment().then((result: any) => {
        if (result) {
          // alert(`Google Pay is available: ${JSON.stringify(result)}`);
          this.googlePayButton.mount('#google-pay-button');
          this.isPaymentIntentLoaded = true;
        } else {
          alert(`Google Pay is not available: ${JSON.stringify(result)}`);
          console.log('Google Pay is not available');
        }
      });
      // this.googlePayButton.mount('#google-pay-button');
    }
  }

  get hasFormErrors(): boolean {
    return this.surveyComponent.hasFormErrors;
  }

  async handleSubmit(event: Event) {
    const isError = this.surveyComponent.isFormInvalid(); // Validate the form before submission
    if (isError) {
      // this.toaster.error({ message: `Fill mandatory details`, title: "Error saving form " });
      this.showFormError();     // this.cdr.detectChanges();
      //this.selectedPaymentMethod = ''; // Reset the model value
      //  setTimeout(() => {
      //       this.selectedPaymentMethod = ''; // Reset the model value
      //       this.cdr.detectChanges();  // Force a second detection
      //   }, 0);
      return;
    }

    if (this.itemData()?.isAcceptPaymentOnline) {
      if(this.isPaymentIntentLoaded){
        this.isShowPaymentLoader = true;
        this.spinnerService.showSpinner();
      }
      if (!this.isPaymentIntentLoaded) {
        //this.formSpinnerService.hideFormSpinner();
        this.spinnerService.hideSpinner();
        this.toaster.error({ message: 'Payment initialization failed. Please try again.', title: "Payment Failed" });
        console.error('Payment initialization failed: Missing clientSecret');
        return;
      }
      // Step 1: Confirm the payment using Stripe.js
      const { error, paymentIntent } = this.selectedPaymentMethod === 'card'
        ? await this.confirmCardPayment(this.paymentIntentResponse.clientSecret)
        : this.selectedPaymentMethod === 'bank' ? await this.confirmPayment(this.paymentIntentResponse.clientSecret)
          : { error: { message: 'Unsupported payment method' } };

      if (!this.selectedPaymentMethod) {
        //alert(error.message);  // Show error message to user
        this.isShowPaymentLoader = false;
        this.spinnerService.hideSpinner();
        this.toaster.error({ message: `Please select a Payment Method for your submission.`, title: "Payment method not selected" });
        return;
      }
      else if (error) {
        this.isShowPaymentLoader = false;
        this.spinnerService.hideSpinner();
        this.toaster.error({ message: error?.message ?? 'Unknown Error', title: "Payment Failed" });
        console.error('Payment error:', error);
        //alert('Payment processing, please check your email for updates.'); // For bank transfers, payment might be processing
      }
      else if (
        (this.selectedPaymentMethod === 'bank' && 
          (paymentIntent.status === 'processing' || paymentIntent.status === 'requires_action')) ||
        (this.selectedPaymentMethod === 'card' && paymentIntent.status === 'succeeded')
      ) {
        // this.toaster.success({ message: `Payment done with ${this.selectedPaymentMethod}`, title: "Success Payment" });
        this.isShowPaymentLoader = false;
        //this.formSpinnerService.showFormSpinner();
        this.participateService.hideParticipate();
        //this.surveyComponent.completeSurvey();
        //alert('Payment Successful!');

        // Optionally, you can trigger additional actions, like updating the survey status or completing the user flow
         const header = 'Your payment is complete!';
          this.participateService.showParticipateconf({
            show: true,
            header: header,
          });
          this.spinnerService.hideSpinner();
      }
      else {
        this.spinnerService.hideSpinner();
        const failedObj = {
          message: 'Payment failed and requires additional action.',
          paymentStatus: paymentIntent.status,
          paymentMethod: this.selectedPaymentMethod
        }
        this.toaster.error({ message: JSON.stringify(failedObj), title: "Payment Failed" });
        console.error('Payment failed:', failedObj);
        //alert('Payment processing, please check your email for updates.'); // For bank transfers, payment might be processing
      }
    }
    else {

      // If no payment is required, just complete the survey
      //this.formSpinnerService.showFormSpinner();
      this.spinnerService.showSpinner();
      this.surveyComponent.completeSurvey();
      // this.toaster.success({ message: `Form submitted`, title: "Form submitted" });
      // alert('Survey submitted successfully without payment.');
    }
  }

  private async confirmCardPayment(clientSecret: string) {
    return await this.stripe.confirmCardPayment(clientSecret, {
      payment_method: {
        card: this.card,
        billing_details: {
          name: this.fullName, // You can fetch this dynamically from your form
          email: this.email,
          phone: this.phone,
          address: {
            // line1: this.address,
            // line2: this.address2,
            // city: this.city,
            postal_code: this.postalCode,
            // country: this.country
          }
        }
      }
    });
  }


  private async confirmPayment(clientSecret: string) {
    return await this.stripe.confirmPayment({
      elements: this.elements,
      confirmParams: {
        // return_url: window.location.href, // or your custom return URL
        payment_method_data: {
          billing_details: {
            name: this.fullName,
            email: this.email,
            phone: this.phone,
            address: {
              // line1: this.address,
              // line2: this.address2,
              // city: this.city,
              postal_code: this.postalCode,
              // country: this.country
            }
          }
        }
      },
      redirect: 'if_required'
    });
  }


  onSurveyDataReceived(data: any): void {
    //this.formSpinnerService.showFormSpinner();
    this.spinnerService.showSpinner();
    if (this.isProposeForm) {
      this.participateService.hideParticipate();
    }
    if (this.itemData()?.isAcceptPaymentOnline) {

      setTimeout(() => {
         this.participateService.showParticipateconf({
        show: true,
        header: 'Your payment is complete!',
      });

      this.spinnerService.hideSpinner();
      }, 1000);
      // this.participateService.hideParticipate();
     
    } 
    else
    {
    // Optionally send to backend
    const formsubmit: FormSubmitDto = {
      itemId: this.itemData()?.id, // Assuming you have an item ID, otherwise set to 0 or undefined
      communityId: this.itemData()?.communityId ?? this.communityId, // Replace with actual community ID
      isOnlinePayment: !!this.itemData()?.isAcceptPaymentOnline,
      formValues: data,
      formId: this.itemData().formMasterId ?? this.proposeFormId,
      paymentMethod: (this.itemData()?.isAcceptPaymentOnline && this.selectedPaymentMethod) ?
        this.selectedPaymentMethod === 'bank' ? 54 : 53
        : undefined,
      price: this.itemData()?.isAcceptPaymentOnline ?
        this.itemData().itemListingType === ItemListingTypeEnum.Custom ? this.customItemPrice() : this.itemData().price
        : undefined,
      isVolunteer: this.itemData()?.campaignTypeId === CampaignTypeEnum['Volunteer Activity'],
      paymentIntentId: this.paymentIntentResponse?.id,
      volunteerShiftId: this.selectedShift()?.id,
    };
    this.participateService.hideParticipate();
    //this.formSpinnerService.showFormSpinner();
      this.spinnerService.showSpinner();
    this.appFormService.submitForm(formsubmit).subscribe({
      next: () => {
        const header = this.itemData()?.isAcceptPaymentOnline ? 'Your payment is complete!' : 'Your submission is complete!';
        this.participateService.showParticipateconf({ show: true, header: header });
        //this.formSpinnerService.hideFormSpinner();
        this.spinnerService.hideSpinner();
      },

      error: (error) => {
        this.participateService.showParticipateconf({ error: 'Validation error' });
        //this.formSpinnerService.hideFormSpinner();
        this.spinnerService.hideSpinner();
        this.toaster.error({ message: `Some error occurred during saving the form: ${JSON.stringify(error)}`, title: "Error saving form " });
        console.error('Some error occurred during saving the form', error);
      }
    });
    }
  }

  isValidFilesSize = true;
  onIsValidFilesSize(isValidFilesSize: boolean): void {
    this.isValidFilesSize = isValidFilesSize;
    if (!isValidFilesSize) {
      this.selectedPaymentMethod = null;
      this.toaster.error({ message: 'The total file size exceeds the 20 MB upload limit. Please remove some files and try again.', title: 'File upload size exceeded' });
      // this.cdr.detectChanges();
    }
  }

  invalidExtensionMessage = '';
  onSurveyFileExtnValidation(invalidExtensionMessage: string): void {
    this.invalidExtensionMessage = invalidExtensionMessage;
    if (invalidExtensionMessage) {
      this.selectedPaymentMethod = null;
      this.toaster.error({ message: invalidExtensionMessage, title: "Unsupported file format" });
      // this.cdr.detectChanges();
    }
  }

  invalidExtensionMessageCombined = '';
  onSurveyFileExtnValidationCombined(invalidExtensionMessageCombined: string): void {
    this.invalidExtensionMessageCombined = invalidExtensionMessageCombined;
  }

  isFormValid = false;
  onIsFormValid(isValid: boolean): void {
    this.isFormValid = isValid;
    if (!isValid) {
      this.showFormError();
      // this.cdr.detectChanges();
      // this.toaster.error({ message: 'Please fill all required fields.', title: 'Form Validation Error' });
    }
  }

  private showFormError() {
    this.selectedPaymentMethod = null;
    if (!this.isValidFilesSize) {
      this.toaster.error({ message: 'The total file size exceeds the 20 MB upload limit. Please remove some files and try again.', title: 'File upload size exceeded' });
    }
    else if (this.invalidExtensionMessageCombined) {
      this.toaster.error({ message: this.invalidExtensionMessageCombined, title: 'Unsupported file format' });
    }
    else {
      this.toaster.error({ message: 'There are errors in this form. Please correct them before moving on.', title: "Error in form " });
    }
  }

  onCloseFormDialog(): void {
    this.smlCancelSurveyModal.closeModal();
    this.showCancelSurveyDialog = false;
  }

  onClosePopup() {
    this.showCancelSurveyDialog = false;
  }

  onConfirmCloseFormDialog() {
    this.closeParticipateModal.emit();
    this.smlCancelSurveyModal.closeModal();
    this.showCancelSurveyDialog = false;
  }

  getDefaultImage(campaignTypeId?: number | null): string{
    switch (campaignTypeId) {
      case this.campaignTypeEnums['Volunteer Activity']:
        return 'https://learn.seemylegacy.com/hubfs/App%20Graphics/Item%20Default%20images/Volunteer%20-%20Default%20Image.jpg';
      case this.campaignTypeEnums['Memorial Program']:
        return 'https://learn.seemylegacy.com/hubfs/App%20Graphics/Item%20Default%20images/Memorial%20Item%20-%20Default%20Image.jpg';
      case this.campaignTypeEnums['Sponsorship + Fundraiser']:
        return 'https://learn.seemylegacy.com/hubfs/App%20Graphics/Item%20Default%20images/Sponsorship%20Fundraiser%20-%20Default%20Image.jpg';
      case this.campaignTypeEnums.Other:
        return 'https://learn.seemylegacy.com/hubfs/App%20Graphics/Item%20Default%20images/Community%20Initiative%20-%20Default%20Image.jpg';
      case CampaignTypeEnumm['Sponsorship']:
        return 'https://learn.seemylegacy.com/hubfs/App%20Graphics/Item%20Default%20images/Sponsorship%20Default%20Image.jpeg';
      case CampaignTypeEnumm['Fundraiser']:
        return 'https://learn.seemylegacy.com/hubfs/App%20Graphics/Item%20Default%20images/Fundraiser%20-%20Default%20Image.jpg';
      case CampaignTypeEnumm['Registration']:
        return 'https://learn.seemylegacy.com/hubfs/App%20Graphics/Item%20Default%20images/Registration%20Default%20Image.jpeg';
      case CampaignTypeEnumm['Interactive Tour']:
        return 'https://learn.seemylegacy.com/hubfs/App%20Graphics/Item%20Default%20images/Interactive%20Tour%20-%20Default%20Image.jpg';
      default:
        return './assets/images/placeholder.png';
    }
  }
}

export const FORM_DETAIL_STRINGS = {
  CLOSE_FORM: 'Cancel Progress?',
  CLOSE_FORM_SUBHEADING: 'If you exit the form, you will lose all progress on your submission.',
  CLOSE_FORM_SAVE_TEXT: 'Exit Form',
  CLOSE_FORM_CANCEL_TEXT: 'No, Continue with Form',
} as const;
